function safeString(value) {
  return String(value == null ? "" : value).trim();
}

function normalizeFieldKey(value) {
  return safeString(value).toLowerCase().replace(/[^a-z0-9]/g, "");
}

const LEASE_TO_PAGE_KEYWORDS = Object.freeze({
  tenantFullName: ["tenantfullname", "tenantname", "tenantfirstname"],
  tenantEmail: ["tenantemail", "email"],
  tenantPhone: ["tenantphone", "phone"],
  suiteNumber: ["suitenumber", "suite", "unitnumber", "unit"],
  rentAmount: ["baserent", "rentamount", "rent"],
  startDate: ["startdate", "moveindate", "rentstartdate"],
  endDate: ["enddate", "fixedenddate"],
  securityDeposit: ["securitydeposit", "damagedeposit", "rentdeposit"],
  rentFrequency: ["rentfrequency", "frequency"],
  utilities: ["utilities", "services"],
  parking: ["parking"],
  pets: ["pets", "pet"],
  smoking: ["smoking"],
});

export function mapLeaseFieldsToPageProposals(leaseFields, pageContext) {
  const fields = leaseFields && typeof leaseFields === "object" ? leaseFields : {};
  const fillable = Array.isArray(pageContext?.fillableFields) ? pageContext.fillableFields : [];
  const proposals = [];
  const usedKeys = new Set();

  Object.entries(fields).forEach(([leaseFieldKey, leaseField]) => {
    const value = safeString(leaseField?.value);
    if (!value) return;

    const targetKeywords = LEASE_TO_PAGE_KEYWORDS[leaseFieldKey] || [normalizeFieldKey(leaseFieldKey)];
    const matched = fillable.find((field) => {
      if (!field?.fieldKey) return false;
      const key = normalizeFieldKey(field.fieldKey);
      const label = normalizeFieldKey(field.label);
      return targetKeywords.some((needle) => key.includes(needle) || label.includes(needle));
    });

    if (!matched || usedKeys.has(matched.fieldKey)) return;
    usedKeys.add(matched.fieldKey);
    proposals.push({
      fieldKey: matched.fieldKey,
      value,
      confidence: Number(leaseField.confidence || 0),
      reason: `Mapped from lease field ${leaseFieldKey}`,
    });
  });

  return proposals;
}

export function applyProposalsToObject(baseState, proposals) {
  const next = { ...(baseState || {}) };
  const rows = Array.isArray(proposals) ? proposals : [];
  rows.forEach((proposal) => {
    const key = safeString(proposal?.fieldKey);
    if (!key) return;
    next[key] = proposal?.value == null ? "" : String(proposal.value);
  });
  return next;
}
